<template>
  <div id="page_app">
    <v-dialog v-model="dialog" persistent width="700">
      <v-card>
        <v-toolbar color="primary" dark flat dense cad>
          <v-toolbar-title class="subheading">{{labeldialog}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDialog()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="text-xs-left">
          <v-form v-model="valid" ref="form" lazy-validation>
            <v-container>
              <v-layout fluid wrap>
                <v-flex lg6 sm6 xs12>
                  <v-text-field label="Title" name="name" v-model="adddata.name"></v-text-field>
                </v-flex>
                <v-flex lg6 sm12 xs12>
                  <v-text-field label="Target Url (Optional)" name="image" v-model="adddata.url"></v-text-field>
                </v-flex>
                <v-flex lg12 sm12 xs12>
                  <input
                    hidden
                    label="Upload"
                    name="imageupload"
                    type="file"
                    accept="image/*"
                    ref="imageupload"
                    v-on:change="upload($event.target.files)"
                  />
                </v-flex>

                <v-flex lg12 sm12 xs12>
                  <img
                    id="imgbanner"
                    class="imgslide"
                    src="https://placehold.co/600x200"
                    alt="image"
                    @click="openfile()"
                    width="100%"
                    height="300"
                  />
                </v-flex>
                <v-flex lg6 sm12 xs12>
                  <v-select
                    label="Status"
                    item-text="text"
                    item-value="status"
                    v-model="adddata.status"
                    :items="statuses"
                  ></v-select>
                </v-flex>
                <v-flex lg4 sm4 xs4>
                  <v-text-field
                    label="Sort Order"
                    name="order"
                    type="number"
                    v-model="adddata.order"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="closeform()">Cancel</v-btn>
          <v-btn color="success" :loading="loading" :disabled="loadingupload" @click="simpanForm(adddata)">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
          <v-card>
            <v-toolbar elevation="0">
              <v-text-field
                flat
                solo
                prepend-icon="search"
                placeholder="Type something"
                v-model="search"
                hide-details
                class="hidden-sm-and-down"
              ></v-text-field>
              <v-spacer></v-spacer>
              <v-btn color="success" @click.native="openmodal()">
                <v-icon dark>add</v-icon>Add
              </v-btn>
              <v-btn class="ml-2" color="primary" @click.native="getNews()">
                <v-icon dark>refresh</v-icon>Refresh
              </v-btn>
            </v-toolbar>

            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table
                :headers="complex.headers"
                :search="search"
                :items="list"
                class="elevation-1"
                item-key="id"
                show-select
                :loading="loading"
                v-model="complex.selected"
              >
                <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>
<!--                <template v-slot:progress>-->
<!--                  <v-skeleton-loader-->
<!--                          v-if="loading"-->
<!--                          height="100"-->
<!--                          type="table-tbody"-->
<!--                  >-->
<!--                  </v-skeleton-loader>-->
<!--                </template>-->
                <template v-slot:item.image="{ item }">
                  <div class="ma-2">
                    <v-img :src="item.image" contain
                           aspect-ratio="1.5" class="pa-2">
                    </v-img>
                  </div>
                </template>
                <template v-slot:item.status="{ item }">
                  <div class="ma-4 text-xs-left">
                    <v-chip
                            v-if="item.status===1"
                            color="green"
                            small
                            text-color="white"
                    >{{ statusformat(item.status) }}</v-chip>
                    <v-chip
                            v-else
                            color="red"
                            small
                            text-color="white"
                    >{{ statusformat(item.status) }}</v-chip>
                  </div>
                </template>

                <template v-slot:item.action="{ item }">
                  <div class="ma-4 text-xs-left">
                    <v-btn @click.native="openFormEdit(item)" icon small>
                      <v-icon color="primary" small>edit</v-icon>
                    </v-btn>
                    <v-btn @click.native="deleteItem(item)" icon small>
                      <v-icon color="pink">delete</v-icon>
                    </v-btn>
                  </div>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import moment from 'moment'
// import draggable from 'vuedraggable'
// import Sortable from 'sortablejs'

export default {
  components: {},
  data: () => ({
    state_add: false,
    search: '',
    labeldialog:'Add New',
    editable: true,
    isDragging: false,
    delayedDragging: false,
    selected_combo: '',
    statuses: [
      {
        status: 1,
        text: 'Enable'
      },
      {
        status: 0,
        text: 'Disable'
      }
    ],
    editorOption: {},
    valid: false,
    complex: {
      selected: [],
      headers: [
        {
          text: 'Image',
          value: 'image'
        },
        {
          text: 'Title',
          value: 'name'
        },
        {
          text: 'Target URL',
          value: 'url'
        },
        {
          text: 'Status',
          value: 'status'
        },
        {
          text: 'Sort Order',
          value: 'order'
        },
        {
          text: 'Action',
          value: 'action'
        }
      ],
      items: []
    },
    delete_id: '',
    adddata: {
      appid: '',
      name: '',
      order: 1,
      status: 0,
      url: 'https',
      image:"https://placehold.co/600x200"
    }
  }),
  created () {
    // this.getApplist();
  },
  mounted () {
    this.getNews()
    this.resetimage()
  },
  computed: {
    ...mapState('Slider', ['list', 'dialog', 'loading']),
    ...mapState('UploadImage', ['defaultimg','loadingupload'])
  },
  methods: {
    ...mapActions({
      logout: 'account/logout',
      AddNew: 'Slider/Add',
      EditSlider: 'Slider/Edit',
      closeDialog: 'Slider/closeDialog',
      OpenDialogForm: 'Slider/OpenDialogForm',
      getNews: 'Slider/list',
      delete_news: 'Slider/Delete',
      uploadImage: 'UploadImage/uploadImage',
      resetimage:'UploadImage/resetimage'
    }),
    closeform () {
      this.adddata.name = ''
      this.adddata.image ='https://placehold.co/600x200';
      this.adddata.url = ''
      this.adddata.appid = ''
      this.closeDialog()
      this.state_add = false
      this.getNews()
    },
    async openFormEdit (data) {
      this.adddata = data
      this.labeldialog='Edit Slider'
      this.state_add = false
      await this.OpenDialogForm()
      document.getElementById('imgbanner').src = this.adddata.image
    },
    async openmodal () {
      await this.resetimage();
      this.state_add = true
      this.labeldialog='Add New'
      this.adddata={
        order:1,
        status:1
      }
      await this.OpenDialogForm()
      // document.getElementById('imgbanner').src =
      //   'https://res.cloudinary.com/irsmax/image/upload/v1556795025/placeholderirs.png'

    },
    async simpanForm (data) {
      if (this.state_add) {
        data.image=this.defaultimg
        await this.AddNew(data)
      } else {
        if(this.defaultimg.length>0){
          data.image=this.defaultimg
        }
        await this.EditSlider(data)
      }
      await this.resetimage();
      this.state_add = false
      this.closeform()
    },
    async deleteItem (data) {
      this.delete_id = data.id
      this.$confirm('Yakin akan hapus ?', { color: 'red',title:'Hapus',icon:'fa-danger' }).then(res => {
        if (res) {
          this.delete_news(this.delete_id);
        }
      })
    },
    upload: function (files) {
      this.showPreview(files[0])
    },
    showPreview: function (file) {
      var reader = new FileReader()
      if(file){
        this.uploadImage(file);
      }
      reader.onload = function (e) {
        document.getElementById('imgbanner').src = e.target.result
      }
      reader.readAsDataURL(file)
    },
    openfile () {
      document.getElementsByName('imageupload')[0].click()
      // this.$refs.imageupload.click();
    },
    statusformat (value) {
      let a = 'Disable'
      if (value === 1) {
        a = 'Enable'
      }
      return a
    },
    formatDate (value) {
      return moment(String(value)).format('DD/MM/YYYY HH:mm:ss')
    }
  }
}
</script>

<style lang="stylus" scoped>
.quill {
  height: 300px;
  padding-bottom: 95px;
}

.tdlist {
  padding: 10px !important;
}

.padding-left {
  padding-left: 10px !important;
}

.imgslide {
  width: 100%;
  height: 200px;
  background-repeat: no-repeat;
}

.imgslidelist {
  width: 300px;
  height: 100px;
}

.flip-list-move {
  transition: transform 0.5s;
}

.no-move {
  transition: transform 0s;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.list-group {
  min-height: 20px;
}

.list-group-item {
  cursor: move;
}

.list-group-item i {
  cursor: pointer;
}

.handle {
  cursor: move !important;
  cursor: --webkit-grabbing !important;
}
</style>
